import { useMemo } from 'react';

import { useDeviceIdList } from '@/api/deviceIdList';
import { useIsAdmin } from '@/api/userAccount';
import { useOptionalSpotterContext } from '@/context/SpotterContext';

export const useIsSharedDevice = (spotId?: string | null) => {
    const { spotterId } = useOptionalSpotterContext({ spotterId: spotId });
    const isAdmin = useIsAdmin();
    const { data: deviceIdListResponse } = useDeviceIdList();

    const isSharedDevice = useMemo(() => {
        if (isAdmin) {
            // admins shouldn't actually own any devices, but most APIs return indistinguishable responses between owners and admins
            return true;
        }

        if (!spotterId || !deviceIdListResponse?.data?.devices.length) {
            return false;
        }
        const matchedDevice = deviceIdListResponse?.data.devices.find((d) => d.spotterId === spotterId);
        if (!matchedDevice) {
            return false;
        }
        return !matchedDevice.isAuthorizedToBeUpdated;
    }, [deviceIdListResponse?.data.devices, isAdmin, spotterId]);

    return isSharedDevice;
};
